function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Divider, Icon } from "../../..";
import React, { useState } from 'react';
import "./index.less";
var MobileNavigation = function MobileNavigation(props) {
  var onShoppingCart = props.onShoppingCart,
    onLogin = props.onLogin,
    closeMobile = props.closeMobile,
    openMobile = props.openMobile,
    _props$cartNum = props.cartNum,
    cartNum = _props$cartNum === void 0 ? 0 : _props$cartNum,
    _props$showCount = props.showCount,
    showCount = _props$showCount === void 0 ? true : _props$showCount;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showMenu = _useState2[0],
    setShowMenu = _useState2[1];
  var handleOpenMobile = function handleOpenMobile() {
    setShowMenu(false);
    if (openMobile) {
      openMobile();
    }
  };
  var handleCloseMobile = function handleCloseMobile() {
    setShowMenu(true);
    if (closeMobile) {
      closeMobile();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-item",
    onClick: onShoppingCart
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "shopping-cart",
    className: "mobile-item-icon"
  }), showCount && /*#__PURE__*/React.createElement("span", {
    className: "shopping-cart-count"
  }, /*#__PURE__*/React.createElement("span", null, cartNum))), /*#__PURE__*/React.createElement(Divider, {
    direction: "vertical",
    className: "mobile-item-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-item login",
    onClick: onLogin
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "person",
    className: "mobile-item-icon"
  })), showMenu === true ? /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-item",
    onClick: handleOpenMobile
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "line-3",
    className: "mobile-item-icon"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "iron-header-mobile-item",
    onClick: handleCloseMobile
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    className: "mobile-item-icon"
  })));
};
export default MobileNavigation;